module.exports = __webpack_public_path__ + "img/he3.336bae14.png";